var map = {
	"./en": "aeb6",
	"./en.js": "aeb6",
	"./es": "e571",
	"./es.js": "e571",
	"./zh-CN": "785c",
	"./zh-CN.js": "785c",
	"./zh-TW": "e9dc",
	"./zh-TW.js": "e9dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2e6";